// extracted by mini-css-extract-plugin
export var centerPosition = "Sidebar-module--centerPosition--0b28e";
export var container = "Sidebar-module--container--19a74";
export var rightPosition = "Sidebar-module--rightPosition--0e312";